<form [formGroup]="form" (ngSubmit)="salvar()" class="execucao-orcamentaria-itens">
  <mat-accordion class="" multi [togglePosition]="'before'">
    <ng-container *ngFor="let itens of list;">
      <mat-expansion-panel class="mb-2">
        <mat-expansion-panel-header>
          <div>
            <h3>{{ itens?.name_list }}</h3>
          </div>
        </mat-expansion-panel-header>
        <div class="system-table table-container table-form">
          <div class="system-table-conteiner system-table-form-conteiner">
            <table>
              <thead>
                <tr>
                  <th *ngIf="lowercase(itens?.name_table) != 'projeto'"></th>
                  <th class="text-center width5" >Código</th>
                  <th class="title-th">{{itens?.name_show}}</th>
                  <th *ngIf="lowercase(itens?.name_table) == 'entrega'" class="text-center title-th">Entrega</th>
                  <ng-container *ngIf="permission?.execucao_orcamentaria_manual">
                    <th class="text-center" *ngIf="permission?.can_see_manual_goal">Previsão</th>
                    <th class="text-center">Dotação LOA</th>
                    <th class="text-center">Empenhado</th>
                    <th class="text-center">Liquidado</th>
                    <th class="text-center">
                      Pago
                      <button matButton="elevated" #tooltip="matTooltip" *ngIf="!permission?.execucao_orcamentaria_manual"
                        matTooltip="No sistema FPE, corresponde à soma do Pago + Pagamento Regularizado"
                        class="btn-help"
                        matTooltipHideDelay="200"
                        aria-label="No sistema FPE, corresponde à soma do Pago + Pagamento Regularizado"
                        >
                      question_mark
                    </button>
                    </th>
                    <th class="text-center">Liquidado Exercício Anterior</th>
                    <th class="text-center">
                      Pago Exercício Anterior
                      <button matButton="elevated" #tooltip="matTooltip" *ngIf="!permission?.execucao_orcamentaria_manual"
                          matTooltip="No sistema FPE, corresponde à soma do Pago + Pagamento Regularizado"
                          class="btn-help"
                          matTooltipHideDelay="200"
                          aria-label="No sistema FPE, corresponde à soma do Pago + Pagamento Regularizado"
                          >
                        question_mark
                      </button>
                    </th>
                    <th class="text-center">Observações - Fonte e forma de levantamento</th>
                  </ng-container>
                </tr>
              </thead>
              <tbody [formArrayName]="lowercase(itens?.name_table)">
                <ng-container *ngIf="itens?.list?.length">
                  <tr *ngFor="let item of itens?.list; let i = index" [formGroupName]="i">
                    <td class="width5" *ngIf="lowercase(itens?.name_table) != 'projeto'">
                      <div class="form-group row">
                        <div class="col-sm-12">
                          <div class="switch">
                            <div class="onoffswitch">
                              <input type="checkbox" formControlName="checked" (change)="item.checked = !item?.checked; habilitaForm(i, lowercase(itens?.name_table), item?.checked);"  class="onoffswitch-checkbox" id="{{i+itens?.name_table}}">
                              <label class="onoffswitch-label" for="{{i+itens?.name_table}}">
                                <span class="onoffswitch-inner switchCheck"></span>
                                <span class="onoffswitch-switch"></span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="text-center width5" [ngClass]="{'level_mon_id' : item?.level_mon_id == 1}">{{ item?.code }}</td>
                    <td  class="title-td">
                      {{item?.title}}
                      <div class="responsavel">
                        <img *ngIf="!item?.pf_id && item?.resp_nome" src="assets/images/svgs/responsavel.svg" alt="Responsavel" [tooltip]="item?.resp_nome" placement="bottom" (click)="viewResonsavel(item)">
                        <div *ngIf="item?.level_mon_id == 1" class="tag">Estratégico</div>
                      </div>
                    </td>
                    <td *ngIf="lowercase(itens?.name_table) == 'entrega'" class="text-center">
                      <span class="font-icon-fill flag" *ngIf="item?.end_is_milestone || item?.start_is_milestone" title="É um Marco">flag_2</span>
                    </td>
                    <ng-container *ngIf="permission?.execucao_orcamentaria_manual">
                      <td *ngIf="permission?.can_see_manual_goal">
                        <div class="form-group">
                          <div class="col-sm-12">
                            <input type="text" class="form-control text-right" [readOnly]="!permission?.can_manual_goal" formControlName="previsao" (keyup)="formatarMedidaFisica(i, 'previsao', lowercase(itens?.name_table))">
                          </div>
                        </div>
                      </td><td>
                        <div class="form-group">
                          <div class="col-sm-12">
                            <input type="text" class="form-control text-right"  formControlName="dotacao_loa" (keyup)="formatarMedidaFisica(i, 'dotacao_loa', lowercase(itens?.name_table))">
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="form-group">
                          <div class="col-sm-12">
                            <input type="text" class="form-control text-right" [readOnly]="!permission?.can_manual_pledged" formControlName="empenhado" (keyup)="formatarMedidaFisica(i, 'empenhado', lowercase(itens?.name_table))">
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="form-group">
                          <div class="col-sm-12">
                            <input type="text" class="form-control text-right" [readOnly]="!permission?.can_manual_done" formControlName="liquidado" (keyup)="formatarMedidaFisica(i, 'liquidado', lowercase(itens?.name_table))">
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="form-group">
                          <div class="col-sm-12">
                            <input type="text" class="form-control text-right" [readOnly]="!permission?.can_manual_paid" formControlName="pago" (keyup)="formatarMedidaFisica(i, 'pago', lowercase(itens?.name_table))">
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="form-group">
                          <div class="col-sm-12">
                            <input type="text" class="form-control text-right" [readOnly]="!permission?.can_manual_done" formControlName="liquidado_exercicio_anterior" (keyup)="formatarMedidaFisica(i, 'liquidado_exercicio_anterior', lowercase(itens?.name_table))">
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="form-group">
                          <div class="col-sm-12">
                            <input type="text" class="form-control text-right" [readOnly]="!permission?.can_manual_paid" formControlName="pago_exercicio_anterior" (keyup)="formatarMedidaFisica(i, 'pago_exercicio_anterior', lowercase(itens?.name_table))">
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="form-group">
                          <div class="col-sm-12">
                            <input type="text" class="form-control text-right" [readOnly]="!permission?.can_manual_done" formControlName="observacoes">
                          </div>
                        </div>
                      </td>
                    </ng-container>
                  </tr>
                </ng-container>
                <tr *ngIf="!itens?.list?.length" class="border-b-radius">
                  <td class="text-center" [attr.colspan]="permission?.execucao_orcamentaria_manual ? (permission?.can_see_manual_goal ? '10' : '11') : '4'">
                    Nenhum(a) {{itens?.name_table}} cadastrado(a) nesse Projeto.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
          
    
        
      </mat-expansion-panel>
    </ng-container>
  </mat-accordion>

  <div class="hr-line-dashed"></div>
  <div class="form-group row d-flex justify-content-end">
    <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
      <button class="btn btn-primary btn" *ngIf="!permission?.readonly_budget_select" type="submit">Salvar</button>
    </div>
  </div>
</form>

<br>
<app-historico-atualizacoes-list [listAudit]="listAudit" [loadList]="false" [key]="'budget_id'"></app-historico-atualizacoes-list>
<app-loading [loader]="isLoading"></app-loading>
<app-modal-responsavel #modalResonsavel></app-modal-responsavel>